import "./Card.css";
function Card(props) {
  return (
    <div>
      <div className="card">
        <div className="cont">
          <h1> {props.name} </h1>
          <p className="desc"> {props.desc}</p>
          <p className="tech"> {props.techs} </p>

          <a href={props.link} target="_blank" rel="noreferrer">
            <button> view project </button>
          </a>
        </div>

        <img src={`/portfolio/${props.imgSrc}.jpg`} alt="" className="img" />
      </div>
    </div>
  );
}

export default Card;
